var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmailLogo = function SvgGmailLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gmailLogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M7.317 23.882v-12.3l-3.814-3.49L.082 6.157v15.556a2.17 2.17 0 0 0 2.17 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M24.682 23.882h5.064a2.17 2.17 0 0 0 2.17-2.17V6.156l-3.874 2.218-3.36 3.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m7.318 11.581-.52-4.806.52-4.6L16 8.688l8.682-6.511.58 4.351-.58 5.054L16 18.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M24.682 2.177v9.405l7.235-5.426V3.262c0-2.684-3.064-4.214-5.21-2.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M.082 6.156 3.41 8.652l3.907 2.93V2.177L5.291.657C3.142-.953.082.577.082 3.262z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gmailLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.078 0h31.843v24H.078z"
  })))));
};
export default SvgGmailLogo;